export default __webpack_public_path__ + "static/media/auth-pattern-dark.b5dde583.svg";